import Services from "api/ProjectApiConsumer";
import { ACCESS_TOKEN, API_BASE_URL } from "constants/index";

export function getFiles() {
  return Services.importAdminService.getFiles();
}

export function deleteFileImported(id) {
  return Services.importAdminService.deleteFileImported(
    undefined,
    undefined,
    id
  );
}

export function saveCashFlow(obj) {
  return fetch(API_BASE_URL + "/import/cash-flow", {
    method: "POST",
    headers: { authorization: localStorage.getItem(ACCESS_TOKEN) },
    body: obj,
  }).then((response) =>
    handleErrors(
      response,
      obj,
      API_BASE_URL + "/import/cash-flow",
      { authorization: localStorage.getItem(ACCESS_TOKEN) },
      "POST"
    )
  );
}

export function saveCategory(obj) {
  return fetch(API_BASE_URL + "/import/category", {
    method: "POST",
    headers: { authorization: localStorage.getItem(ACCESS_TOKEN) },
    body: obj,
  }).then((response) =>
    handleErrors(
      response,
      obj,
      API_BASE_URL + "/import/category",
      { authorization: localStorage.getItem(ACCESS_TOKEN) },
      "POST"
    )
  );
}
export function saveMappingCashFlow(obj) {
  return fetch(API_BASE_URL + "/import/mapping-cash-flow", {
    method: "POST",
    headers: { authorization: localStorage.getItem(ACCESS_TOKEN) },
    body: obj,
  }).then((response) =>
    handleErrors(
      response,
      obj,
      API_BASE_URL + "/import/mapping-cash-flow",
      { authorization: localStorage.getItem(ACCESS_TOKEN) },
      "POST"
    )
  );
}
export function saveMappingIncome(obj) {
  return fetch(API_BASE_URL + "/import/mapping-income", {
    method: "POST",
    headers: { authorization: localStorage.getItem(ACCESS_TOKEN) },
    body: obj,
  }).then((response) =>
    handleErrors(
      response,
      obj,
      API_BASE_URL + "/import/mapping-income",
      { authorization: localStorage.getItem(ACCESS_TOKEN) },
      "POST"
    )
  );
}

function handleErrors(response, body, url, headers, method) {
  if (!response.ok) {
    throw Error(
      JSON.stringify(
        {
          type: response.type,
          status: response.status,
          message: response.message,
          statusText: response.statusText,
          urlRequest: url,
          headers: headers,
          method: method,
          body: body,
          response: response,
        },
        null,
        1
      )
    );
  }
  return response;
}
